import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import DateUtil from "../../../general/calendar/dateUtil";
import {idempiereDate} from "../../../../../res/dataServices/idempiereDate";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useDeliveryDates from "../../../../services/state/delivery/useDeliveryDates";
import useSession from "../../../../services/state/session/useSession";

const CartDeliveryNote = ({ forPickUp }) => {

    const session = useSession();
    const orderLocation = useCheckoutStore(state => state.order?.C_BPartner_Location_ID);
    const { loading, availableDates } = useDeliveryDates({
        bPartnerID: session.sessionData.bPartnerID,
        top: 10,
        bPartnerLocationID: orderLocation.id,
        forPickUp
    });

    const orderLocationName = orderLocation?.Name;

    const getDisplayDate = () => {
        const dateStr = availableDates[0].available_date;
        const date = idempiereDate.getDate(dateStr);
        return DateUtil.getDisplayDate(date);
    }

    const message = forPickUp ? "Next date for " : "Next delivery date for delivery to ";

    return (
        <div className="cart-delivery-note">
            <LoadingSwitcher loading={loading}>
                {availableDates && availableDates.length > 0 &&
                    <>
                        <p className="cart-note">{message}{availableDates[0].C_BPartner_Location_ID?.identifier}:
                        </p>
                        <p className="cart-note">{getDisplayDate()}</p>
                    </>
                }
                {(!availableDates || availableDates.length === 0) && orderLocationName &&
                    <>
                        <p className="cart-note">No delivery to {orderLocationName}</p>
                    </>
                }
            </LoadingSwitcher>
        </div>
    )
}

export default CartDeliveryNote;
